/*  MUI  */
import {
    IconName,
    IconVariantType,
    IconWithVariant
} from '@auviknetworks/iceberg-ui';
import { Box, Typography } from '@mui/material';

/*  Shared  */
import { TooltipQ } from 'application/Shared/Components/Tooltips';
import { FontSizes } from 'application/Shared/Constants';

/*  React  */
import React from 'react';
import { useTranslation } from 'react-i18next';

export const SimpleHeader = ({
    justifyContent = null,
    text,
    tooltip = '',
    icon
}: {
    justifyContent?: null | string;
    text: string;
    tooltip?: string;
    icon?: {
        src: IconName;
        size?: number;
        tooltipText?: string;
        variant?: IconVariantType;
    };
}) => {
    const { t } = useTranslation();
    return (
        <Box
            display="flex"
            alignItems="center"
            data-testid="tableSimpleHeader"
            sx={{
                ...(tooltip || icon ? { whiteSpace: 'nowrap' } : {}),
                ...(justifyContent ? { justifyContent } : {})
            }}
            width="100%"
        >
            {/* TODO: Remove fontWeight once most of the tables are converted to iceberg tables */}
            <Typography variant="span" fontWeight={600}>
                {t(text)}
                {tooltip && (
                    <TooltipQ
                        text={t(`Tooltips.${tooltip}`)}
                        size={FontSizes[1]}
                    />
                )}
                {icon && (
                    <TooltipQ
                        text={t(icon.tooltipText ?? '')}
                        sx={icon.tooltipText ? undefined : { display: 'none' }}
                        content={
                            <Typography variant="span" display="inline-flex">
                                <IconWithVariant
                                    variant={icon.variant}
                                    src={icon.src}
                                    size={icon.size || FontSizes[1]}
                                    wrapperProps={{ marginLeft: '8px' }}
                                />
                            </Typography>
                        }
                    />
                )}
            </Typography>
        </Box>
    );
};
